import styled from 'styled-components';
import Typography from '~components/dumbs/Typography';

export const Title = styled(Typography).attrs({ as: 'h2' })`
  margin-bottom: ${({ theme }) => theme.spacing.km2};
`;
